/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CampaignListEntryFromJSON, CampaignListEntryToJSON, MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfCampaignListEntryFromJSON(json) {
    return PagedResponseOfCampaignListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfCampaignListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'size': !exists(json, 'size') ? undefined : json['size'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(CampaignListEntryFromJSON))
    };
}
export function PagedResponseOfCampaignListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'size': value.size,
        'nextPage': PageRequestToJSON(value.nextPage),
        'previousPage': PageRequestToJSON(value.previousPage),
        'numberOfElements': value.numberOfElements,
        'hasPrevious': value.hasPrevious,
        'metaData': MetaDataToJSON(value.metaData),
        'hasNext': value.hasNext,
        'totalElements': value.totalElements,
        'page': value.page,
        'entries': value.entries === undefined ? undefined : (value.entries.map(CampaignListEntryToJSON))
    };
}
